import { DevTools, I18nextPlugin, LanguageStorage, Tolgee } from '@tolgee/i18next';
import { I18nResource } from '@/i18n/i18n-supported-language';
import { tolgeeStaticData } from '@/i18n/tolgeeStaticData';

export const tolgee = Tolgee()
  .use(DevTools())
  .use(I18nextPlugin())
  .use(LanguageStorage())
  .init({
    defaultLanguage: I18nResource.TH_TH,
    availableLanguages: Object.values(I18nResource),

    // for development, when these are not present, devTools will not work and it will automatically fallback to staticData
    apiUrl: import.meta.env.VITE_APP_TOLGEE_API_URL,
    apiKey: import.meta.env.VITE_APP_TOLGEE_API_KEY,

    // for production, run `pnpm i18n:pull` to update.
    staticData: tolgeeStaticData,

    onTranslationMissing(_info) {
      return ''; // return empty string to avoid showing the key in the UI when translation is missing
    },
  });
